import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
// Redux
import { useSelector } from "react-redux";
// Constants
import { WEB_SERVICE_MIMS, pathHomePage, primaryColor, primaryColorHover } from "../../../../config/constants";
// Components
import { ActionsManagementContainer, ManagementDiv, AlignContainer, DownloadButton, FileImg, DownloadText } from "./styles";
import UseFetch from "../../../../config/useFetch";
import Button from "../../../button";
// Assets
import CSVImg from "../../../../assets/icons/ico_csv.svg";

const NavigationMenu = () => {
  const [sessions, setSessions] = useState([]);
  const [evaluations, setEvaluations] = useState([]);
  const hospitalId = useSelector(({ clinician }) => clinician.data.HOSPITAL_ID);
  const hospitalName = useSelector(({ clinician }) => clinician.data.HOSPITAL_NAME);
  const { clinicianToken, patientId } = useParams();
  const [t] = useTranslation("global");

  // Fetching Data to export .csv
  useEffect(() => {
    UseFetch("get", `${WEB_SERVICE_MIMS}/icu/get-data-to-export-csv/${hospitalId}`)
      .then(({ data }) => {
        setSessions(data.sessions);
        setEvaluations(data.evaluations);
      })
      .catch((error) => {
        console.log("Get data to export .csv: ", error);
      });

    return () => {
      setSessions([]);
      setEvaluations([]);
    };
  }, [hospitalId]);

  const checkPath = (path1, path2) => {
    return window.location.pathname.includes(path1) || window.location.pathname.includes(path2) ? primaryColorHover : primaryColor;
  };

  const renderLinks = () => {
    const generalMargin = "0 5px 0 0";
    const generalMargin610 = "0";
    const generalWidth610 = "250px";

    const links = [
      {
        name: "sessions",
        path: `${pathHomePage}/prescriptions/icu/${clinicianToken}/${patientId}`,
        background: checkPath("/prescriptions/icu", "/sessions/icu"),
      },
      {
        name: "activities",
        path: `${pathHomePage}/activities/icu/${clinicianToken}/${patientId}`,
        background: checkPath("/activities/icu", "/reports/icu"),
      },
      {
        name: "evaluations",
        path: `${pathHomePage}/evaluations/icu/${clinicianToken}/${patientId}`,
        background: checkPath("/evaluations/icu"),
      },
      {
        name: "comparison",
        path: `${pathHomePage}/comparison/icu/${clinicianToken}/${patientId}`,
        background: checkPath("/comparison/icu"),
      },
    ];

    return links.map((link, i) => (
      <Button
        key={i}
        name={t(link.name)}
        path={link.path}
        margin={generalMargin}
        margin610={generalMargin610}
        width610={generalWidth610}
        background={link.background}
      />
    ));
  };

  const renderCSVButton = () => {
    const generateCSV = () => {
      const sessionsHeaders = [
        `SESSION_ID`,
        `PATIENT_USER`,
        `NAME_KEY`,
        `STARTING_DATE`,
        `ENDING_DATE`,
        `RECORDING_KEY`,
        `RECORDING_VALUE`,
      ];
      const evaluationsHeaders = [
        `EVALUATION_ID`,
        `EVALUATION_UNIT`,
        `PATIENT_USER`,
        `SERVER_DATETIME`,
        `EVALUATION_KEY`,
        `EVALUATION_VALUE`,
      ];

      const sessionsRows = sessions.map((session) => [
        session.SESSION_ID,
        session.PATIENT_USER,
        session.NAME_KEY,
        session.STARTING_DATE,
        session.ENDING_DATE,
        session.RECORDING_KEY,
        session.RECORDING_VALUE,
      ]);

      const evaluationsRows = evaluations.map((evaluation) => [
        evaluation.EVALUATION_ID,
        evaluation.EVALUATION_UNIT,
        evaluation.PATIENT_USER,
        evaluation.SERVER_DATETIME,
        evaluation.EVALUATION_KEY,
        evaluation.EVALUATION_VALUE,
      ]);

      let sessionsCsvContent = sessionsHeaders.join(",") + "\r\n";
      sessionsRows.forEach((row) => {
        sessionsCsvContent += row.join(",") + "\r\n";
      });

      let evaluationsCsvContent = evaluationsHeaders.join(",") + "\r\n";
      evaluationsRows.forEach((row) => {
        evaluationsCsvContent += row.join(",") + "\r\n";
      });

      const sessionsBlob = new Blob([sessionsCsvContent], { type: "text/csv;charset=utf-8;" });
      const evaluationsBlob = new Blob([evaluationsCsvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(sessionsBlob, `${hospitalName}_sessions.csv`);
      saveAs(evaluationsBlob, `${hospitalName}_evaluations.csv`);
    };

    return (
      <DownloadButton onClick={generateCSV}>
        <FileImg src={CSVImg} alt="csv-ico" />
        <DownloadText>{t("download")} CSV</DownloadText>
      </DownloadButton>
    );
  };

  return (
    <ActionsManagementContainer>
      <ManagementDiv>
        <AlignContainer>{renderLinks()}</AlignContainer>
        <AlignContainer>{renderCSVButton()}</AlignContainer>
      </ManagementDiv>
    </ActionsManagementContainer>
  );
};

export default NavigationMenu;
